@charset "UTF-8";

/* src/app/forms/image-selector/image-selector.component.scss */
.image-selector {
  display: flex;
  flex-wrap: wrap;
}
.icon-container {
  position: relative;
  margin: 10px;
}
.icon-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}
.upload-input {
  opacity: 0;
  cursor: pointer;
}
.upload-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.image-preview {
  position: relative;
  margin-top: 10px;
}
.image-preview img {
  width: 200px;
  height: 200px;
  object-fit: cover;
}
.button-container {
  display: flex;
  margin-top: 5px;
  align-items: center;
  justify-content: center;
}
.button-container button {
  padding: 5px;
  cursor: pointer;
}
.custom-image {
  width: 100px;
  height: 100px;
  cursor: pointer;
}
.upload-input {
  opacity: 0;
  cursor: pointer;
}
.custom-dialog-container {
  margin: 0px !important;
  padding: 0px !important;
}
mat-dialog-container {
  padding: 0px !important;
}
.mat-actions {
  float: right;
  margin-bottom: 0px !important;
}
.removeButton {
  background-color: #ff0000 !important;
}
.removeButton {
  min-width: 41px !important;
  line-height: 5px !important;
}
/*# sourceMappingURL=image-selector.component.css.map */
